import apiService from '../services/apiService';

// Web Push im Client (#16 B6, W6).
// ensurePushSubscription() ist idempotent: registriert das Gerät beim Server,
// sobald Benachrichtigungen erlaubt sind und ein Service Worker läuft
// (Produktion; im Dev-Modus gibt es keinen SW → still false).
// Solange eine Subscription aktiv ist, unterdrückt useAutoCache seine eigenen
// Desktop-Benachrichtigungen (window.__pushNotificationsActive) — sonst kämen
// Push UND Poll-Notification doppelt an. Glocke + Ton bleiben clientseitig.

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i++) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

// #499: Passt das Abo im Browser noch zum öffentlichen VAPID-Schlüssel des
// Servers? Nach einer Neuerzeugung der Schlüssel hängt ein altes Abo am alten
// Schlüssel, der Push-Dienst lehnt jede neu signierte Nachricht ab, und auf dem
// Gerät kommt still nichts mehr an. Meldet der Browser den Schlüssel nicht
// (options fehlt), gilt das Abo als passend -- sonst würde jeder Start neu
// abonnieren.
export function aboPasstZuSchluessel(sub, publicKey) {
  const vorhanden = sub && sub.options && sub.options.applicationServerKey;
  if (!vorhanden || !publicKey) return true;
  const a = new Uint8Array(vorhanden);
  const b = urlBase64ToUint8Array(publicKey);
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) return false;
  }
  return true;
}

export async function ensurePushSubscription() {
  try {
    if (typeof window === 'undefined') return false;
    if (!('serviceWorker' in navigator) || !('PushManager' in window) || !('Notification' in window)) return false;
    if (window.Notification.permission !== 'granted') return false;

    const reg = await navigator.serviceWorker.getRegistration();
    if (!reg || !reg.pushManager) return false;

    let publicKey = null;
    try {
      const resp = await apiService.getVapidPublicKey();
      publicKey = resp?.publicKey || null;
    } catch (_) {
      // Ohne Schlüssel kein Vergleich: Ein vorhandenes Abo bleibt wie bisher in Gebrauch.
    }
    let sub = await reg.pushManager.getSubscription();
    if (sub && !aboPasstZuSchluessel(sub, publicKey)) {
      // #499: altes Abo abmelden, beim Server austragen, unten neu abonnieren
      const alterEndpoint = sub.endpoint;
      try { await sub.unsubscribe(); } catch (_) { /* best effort: das neue Abo ersetzt es ohnehin */ }
      try { await apiService.deletePushSubscription(alterEndpoint); } catch (_) { /* best effort: der Server räumt 404/410 selbst ab */ }
      sub = null;
    }
    if (!sub) {
      if (!publicKey) return false;
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey)
      });
    }
    await apiService.savePushSubscription(sub.toJSON ? sub.toJSON() : sub);
    try { window.__pushNotificationsActive = true; } catch (_) {}
    return true;
  } catch (err) {
    try { console.warn('[PUSH] Subscription nicht möglich:', err?.message || err); } catch (_) {}
    return false;
  }
}

// Beim Abmelden: Gerät abmelden, damit keine Pushes mehr ankommen,
// obwohl die Session weg ist. Best effort — Fehler blockieren den Logout nie.
export async function disablePushSubscription() {
  try {
    if (!('serviceWorker' in navigator)) return;
    const reg = await navigator.serviceWorker.getRegistration();
    const sub = reg && reg.pushManager ? await reg.pushManager.getSubscription() : null;
    if (!sub) return;
    const endpoint = sub.endpoint;
    try { await sub.unsubscribe(); } catch (_) {}
    try { await apiService.deletePushSubscription(endpoint); } catch (_) {}
    try { window.__pushNotificationsActive = false; } catch (_) {}
  } catch (_) {}
}
